import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'mwl-demo-utils-calendar-header',
    template: `
        <div class="calendar__bar">                
            <div class="calendar__prev"
                 mwlCalendarPreviousView
                 [view]="view"
                 [(viewDate)]="viewDate"
                 (viewDateChange)="viewDateChange.next(viewDate)">
                Предыдущий месяц
            </div>

            <div class="calendar__current-month">
                <div class="title__capitalize">{{ viewDate | date:'LLLL y' }}</div>
            </div>

            <div class="calendar__next"
                 mwlCalendarNextView
                 [view]="view"
                 [(viewDate)]="viewDate"
                 (viewDateChange)="viewDateChange.next(viewDate)">
                 Следующий месяц
            </div>            
        </div>
    `
})
export class CalendarHeaderComponent {
    @Input() view: string;

    @Input() viewDate: Date;

    @Input() locale: string = 'ru';

    @Output() viewChange: EventEmitter<string> = new EventEmitter();

    @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
}
